{
  "el": {
    "upsell": {
      "categories": {
        "category": "Κατηγορία",
        "home_automation": "Οικιακός αυτοματισμός",
        "integration": "Ενσωμάτωση",
        "interior_decoration": "Εσωτερική διακόσμηση",
        "interior_doors": "Εσωτερικές πόρτες",
        "kitchen": "Κουζίνα",
        "marketing": "Μάρκετινγκ",
        "real_estate_agent": "Μεσίτης ακινήτων",
        "telecom": "Τηλεπικοινωνίες",
        "wood_finishing": "Φινίρισμα ξύλου"
      },
      "contact_us": "Ενδιαφέρεσαι; Επικοινώνησε μαζί μας",
      "decisions_partners": {
        "guidance": "Οι συνεργάτες απόφασης μπορούν να δημιουργούν ή/και να διαχειρίζονται προτάσεις, αν τους δοθεί άδεια.",
        "intercom": "Γεια σου Ziggu, ενδιαφέρομαι για τη λειτουργία Συνεργάτες Απόφασης. Μπορείς να μου δώσεις περισσότερες πληροφορίες; Με εκτίμηση, %{name}"
      },
      "decisions_proposals_multiple_approval": {
        "cta": "Συνομίλησε μαζί μας για να μάθεις περισσότερα",
        "description": "Βαρέθηκες να ακυρώνεις την έγκριση μιας πρότασης για να προσθέσεις αλλαγές και να ξεκινάς από την αρχή; Η ανάγκη για πολλαπλές εγκρίσεις δεν πρέπει να σε καθυστερεί.",
        "description_2": "Άφησε τους πελάτες σου να εγκρίνουν πολλαπλές προτάσεις μέσα στην ίδια απόφαση. Δεν χρειάζεται να ακυρώσεις την έγκριση υπάρχουσας πρότασης ή να ξεκινήσεις νέα απόφαση.",
        "description_3": "Λιγότερη ταλαιπωρία και περισσότερος χρόνος για αυτό που μετράει πραγματικά: τον πελάτη σου.",
        "intercom": "Γεια σου Ziggu, θέλω ο πελάτης να μπορεί να εγκρίνει πολλαπλές προτάσεις μέσα σε μια απόφαση. Μπορείς να μου δώσεις περισσότερες πληροφορίες; Με εκτίμηση, %{name}",
        "premium_add_on": "Πρόσθετο premium",
        "title": "Κέρδισε χρόνο με το ευέλικτο πρόσθετο προτάσεων"
      },
      "decisions_reminders": {
        "guidance": "Οι υπενθυμίσεις σού επιτρέπουν να ειδοποιείς αυτόματα τους πελάτες όταν υπάρχουν προτάσεις που περιμένουν απόφαση.",
        "intercom": "Γεια σου Ziggu, ενδιαφέρομαι για τη λειτουργία Υπενθυμίσεις. Μπορείς να μου δώσεις περισσότερες πληροφορίες; Με εκτίμηση, %{name}"
      },
      "financials": {
        "guidance": "Δημιούργησε προγράμματα δόσεων απευθείας από εγκεκριμένες προτάσεις και μοιράσου τα με τους πελάτες σου μέσω της πύλης πελάτη.<br>Κράτησε την οικονομική επικοινωνία σου διαφανή και επαγγελματική, οι πελάτες έχουν πάντα σαφή εικόνα για το τι οφείλεται και πότε.",
        "intercom": "Γεια σου Ziggu, ενδιαφέρομαι για τη λειτουργία Οικονομικά για δόσεις σε αποφάσεις. Μπορείς να μου δώσεις περισσότερες πληροφορίες; Με εκτίμηση, %{name}"
      },
      "imInterested": "Ενδιαφέρομαι",
      "intercom": "Γεια σου Ziggu, ενδιαφέρομαι να μάθω περισσότερα για το «{upsell}». Μπορείς να μου δώσεις περισσότερες πληροφορίες; Με εκτίμηση, %{name}",
      "interestedToBeListed": "Ενδιαφέρεσαι να καταχωριστείς εδώ",
      "lookingfor": "Τι ψάχνεις; Π.χ. 3D οπτικοποιήσεις, κουζίνα, τηλεπικοινωνίες",
      "multilingual": {
        "announcements_body": "Μπορείς ήδη να μεταφράζεις τις ανακοινώσεις σε {languages}. Παντού αλλού, η λειτουργία multilingual σού επιτρέπει να γράφεις μία φορά και κάθε πελάτης να διαβάζει στη δική του γλώσσα.",
        "bar_covered": "Δημοσιεύεις ήδη στα {language}",
        "bar_uncovered": "Δεν δημοσιεύεις ακόμα στα {language}",
        "body": "Σήμερα λαμβάνουν όλοι την ίδια έκδοση. Με τη λειτουργία multilingual, κάθε πελάτης διαβάζει αυτό το περιεχόμενο στη γλώσσα που έχει επιλέξει.",
        "chip_tooltip": "{customers} πελάτης έχει τα {language} ως γλώσσα του | {customers} πελάτες έχουν τα {language} ως γλώσσα τους",
        "cta": "Ζήτα περισσότερες πληροφορίες",
        "cta_expand": "Εμφάνιση λεπτομερειών",
        "cta_sent": "Θα επικοινωνήσουμε μαζί σου",
        "customers_count": "1 πελάτης | {count} πελάτες",
        "error_intercom": "Δεν μπορέσαμε να στείλουμε την ερώτησή σου. Δοκίμασε ξανά.",
        "headline": "Ο {count} πελάτης σου {scope} μιλάει {languages} | Οι {count} πελάτες σου {scope} μιλούν {languages}",
        "headline_single": "Ο {count} πελάτης σου {scope} μιλάει {language}. | Όλοι οι {count} πελάτες σου {scope} μιλούν {language}.",
        "intercom": "Θα ήθελα να μάθω περισσότερα για τη λειτουργία multilingual",
        "languages_count": "1 γλώσσα | {count} γλώσσες",
        "languages_other_count": "1 ακόμη γλώσσα | {count} ακόμη γλώσσες",
        "missing_add": "Προσθήκη",
        "missing_added": "Τα {language} είναι πλέον μία από τις γλώσσες της εταιρείας σου",
        "missing_hint": "Ό,τι προσθέτεις γίνεται διαθέσιμο ως γλώσσα μετάφρασης παντού, για ολόκληρη την εταιρεία σου.",
        "missing_hint_announcements_only": "Ό,τι προσθέτεις γίνεται γλώσσα μετάφρασης για ολόκληρη την εταιρεία σου. Σήμερα τη χρησιμοποιείς στις ανακοινώσεις· η λειτουργία multilingual την ανοίγει παντού αλλού.",
        "missing_no_permission": "Η προσθήκη γλωσσών εταιρείας απαιτεί τον ρόλο Ιδιοκτήτη.",
        "missing_settings_link": "Διαχειρίσου όλες τις γλώσσες στις ρυθμίσεις της εταιρείας",
        "missing_title": "{count} πελάτης {scope} μιλάει {languages} | {count} πελάτες {scope} μιλούν {languages}",
        "plan": "Enterprise",
        "scope_project": "σε αυτό το έργο",
        "scope_selection": "σε αυτή την επιλογή"
      },
      "not_included": "Ενδιαφέρεσαι για αυτή τη λειτουργία;",
      "project_email_forwarding": {
        "cta": "Προώθηση email σε «{project_name}»",
        "description": "Επίτρεψε σε όλη την ομάδα σου να προωθεί email απευθείας στα έργα σου στο Ziggu.",
        "intercom": "Γεια σου Ziggu, ενδιαφέρομαι για τη λειτουργία προώθησης email έργου. Μπορείς να μου δώσεις περισσότερες πληροφορίες; Με εκτίμηση, %{name}",
        "marketplace": {
          "title": "Προώθηση email έργου",
          "title_sub": "Προώθησε email απευθείας στα έργα σου στο Ziggu."
        },
        "title": "Νέο: Προώθηση email μέσα σε έργα",
        "youtube_id": "vLQtH9GzAXc"
      },
      "project_experience": {
        "contactme": "Ναι, μπορείς να επικοινωνήσεις μαζί μου για αυτό",
        "cta": "Βελτίωση οπτικής ταυτότητας έργου;",
        "description": "Εξατομικευμένο URL έργου και οθόνη σύνδεσης <br/> Αποκλειστικό περιβάλλον έργου μετά τη σύνδεση <br/> Email με την ταυτότητα του έργου <br/> Διευκολύνει τη συνεργασία με άλλους κατασκευαστές ακινήτων στο ίδιο έργο",
        "intercom": "Γεια σου Ziggu, ενδιαφέρομαι για την ενότητα Εμπειρία Έργου. Μπορείς να μου δώσεις περισσότερες πληροφορίες; Με εκτίμηση, %{name}",
        "marketplace": {
          "title": "Εμπειρία έργου",
          "title_sub": "Βελτίωσε την οπτική ταυτότητα του έργου σου με εξατομικευμένο URL και περιβάλλον"
        },
        "title": "Κάνε τους πελάτες σου να νιώσουν σαν στο σπίτι τους με τη νέα Εμπειρία Έργου",
        "youtube_id": "f26cNo2rwWE"
      },
      "project_templates": {
        "cta": "Εισαγωγή από πρότυπο;",
        "cta2": "Εισαγωγή αυτού του προτύπου στα έργα σου; Πάτησε εδώ για να ξεκλειδώσεις αυτή τη λειτουργία",
        "description": "<p>Μεταμόρφωσε τον τρόπο διαχείρισης των έργων σου με έτοιμα πρότυπα που σου εξοικονομούν χρόνο και κρατούν την ομάδα σου συγχρονισμένη.</p><br>\n<p><strong>Οφέλη των προτύπων:</strong></p>\n<ul>\n    <li><strong>- Εξοικονόμησε ώρες</strong> σε επαναλαμβανόμενες εργασίες—εισήγαγε ολόκληρα πλαίσια έργων σε δευτερόλεπτα.</li>\n    <li><strong>- Καλύτερη τυποποίηση</strong> έχοντας τα πάντα σε ένα μέρος, από εργασίες μέχρι έγγραφα.</li>\n    <li><strong>- Αύξησε την αποδοτικότητα</strong> αυτοματοποιώντας τις καθημερινές διαδικασίες, ώστε να επικεντρώνεσαι σε αυτό που μετράει περισσότερο.</li>\n</ul>\n<br/><strong>Αναβάθμισε σήμερα και κάνε περισσότερα με λιγότερη προσπάθεια.</strong>",
        "intercom": "Γεια σου Ziggu, ενδιαφέρομαι για τη λειτουργία προτύπων. Μπορείς να μου δώσεις περισσότερες πληροφορίες; Με εκτίμηση, %{name}",
        "marketplace": {
          "title": "Πρότυπα",
          "title_sub": "Μεταμόρφωσε τον τρόπο διαχείρισης των έργων σου με έτοιμα πρότυπα που σου εξοικονομούν χρόνο και κρατούν την ομάδα σου συγχρονισμένη."
        },
        "title": "Δούλεψε πιο έξυπνα με τα πρότυπα"
      },
      "proposal_choice_lists": {
        "guidance": "Οι λίστες επιλογών σού επιτρέπουν να αφήνεις τους πελάτες να κάνουν επιλογές μέσα σε προτάσεις.",
        "intercom": "Γεια σου Ziggu, ενδιαφέρομαι για τη λειτουργία Λίστες επιλογών. Μπορείς να μου δώσεις περισσότερες πληροφορίες; Με εκτίμηση, %{name}"
      },
      "signatures": {
        "cta_text": "Χρειάζεσαι υπογραφές για τα έγγραφά σου; Επικοινώνησε μαζί μας",
        "guidance": "Οι υπογραφές σού επιτρέπουν να αφήνεις τους πελάτες να υπογράφουν σημαντικά έγγραφα ψηφιακά.",
        "intercom": "Γεια σου Ziggu, ενδιαφέρομαι για τη λειτουργία Υπογραφές. Μπορείς να μου δώσεις περισσότερες πληροφορίες; Με εκτίμηση, %{name}"
      },
      "workflows": {
        "attach_body": "Συμβουλή: και οι αποφάσεις και τα ερωτηματολόγια μπορούν να συνδεθούν με μια φάση. Τότε δημοσιεύονται αυτόματα μόλις φτάσει η σειρά της φάσης.",
        "cta": "Μάθε περισσότερα",
        "cta_sent": "Θα επικοινωνήσουμε μαζί σου",
        "dismiss": "Όχι τώρα",
        "intercom": "Θα ήθελα να μάθω περισσότερα για το τι προσθέτουν τα workflows στις φάσεις.",
        "move_hint_phases": "Συμβουλή: μια φάση μπορεί να δημοσιεύει μόνη της τις αποφάσεις, τα ερωτηματολόγια και τις εργασίες της μόλις φτάσει η σειρά της.",
        "move_hint_tasks": "Συμβουλή: μια φάση μπορεί επίσης να δημοσιεύει μόνη της τις αποφάσεις και τα ερωτηματολόγιά της μόλις φτάσει η σειρά της."
      },
      "workflows_elements": {
        "guidance": "Το τρέχον πακέτο σου δεν περιλαμβάνει αυτόν τον τύπο στοιχείου. Παραμένει στη φάση, αλλά οι πελάτες δεν θα το λάβουν μέχρι να αναβαθμίσεις.",
        "intercom": "Γεια σου Ziggu, ενδιαφέρομαι για την κοινοποίηση αποφάσεων, ερωτηματολογίων και εργασιών μέσω φάσεων. Μπορείς να μου δώσεις περισσότερες πληροφορίες; Με εκτίμηση, %{name}"
      }
    }
  }
}
